<template>
  <main>
    <div class="mb-2 bg-light p-2 rounded-lg border border-light">
      <div class="text-gray-600 small font-weight-bold mb-1 d-flex align-items-center">
        <i class="fas fa-check text-gray-500 mr-2"></i> 
        <span>{{ antecedente_usuario && antecedente_usuario.antecedente ? antecedente_usuario.antecedente.descripcion : '' }}</span>
      </div>
      <div class="text-dark font-weight-400 pl-3">
        {{ valorFormateado }}
      </div>
    </div>
  </main>
</template>
<script>
export default {
  props: ['antecedente_usuario'],
  computed: {
    valorFormateado() {
      if (!this.antecedente_usuario) return '';

      const oldValor = (this.antecedente_usuario.valor || '').trim();
      const details = [];

      // Alergias
      if (this.antecedente_usuario.alergias && this.antecedente_usuario.alergias.length) {
        const alergiasStr = this.antecedente_usuario.alergias.map(a => {
          const parts = [
            a.concepto,
            a.tipo ? `(${a.tipo})` : '',
            a.reaccion ? `Reacción: ${a.reaccion}` : ''
          ].filter(Boolean);
          return parts.join(' ');
        }).filter(Boolean).join(', ');

        if (alergiasStr) details.push(alergiasStr);
      }

      // Condiciones
      if (this.antecedente_usuario.condiciones && this.antecedente_usuario.condiciones.length) {
        const condStr = this.antecedente_usuario.condiciones.map(c => {
          if (!c.diagnostico) return null;
          const desc = c.diagnostico.DESC_DIAG || c.diagnostico.DESCRIPCION;
          const code = c.diagnostico.ID_DIAG || c.diagnostico.COD_DIAG;
          if (code && desc) {
            return `[${code}] ${desc}`;
          }
          return desc || code || null;
        }).filter(Boolean).join(', ');

        if (condStr) details.push(condStr);
      }

      // Medicamentos
      if (this.antecedente_usuario.medicamentos && this.antecedente_usuario.medicamentos.length) {
        const medStr = this.antecedente_usuario.medicamentos.map(m => {
          const name = m.medicamento_dci ? m.medicamento_dci.nombre : (m.medicamentoDci ? m.medicamentoDci.nombre : m.concepto);
          const info = [name, m.dosis ? `Dosis: ${m.dosis}` : '', m.frecuencia ? `Frecuencia: ${m.frecuencia}` : ''].filter(Boolean);
          return info.join(' - ');
        }).filter(Boolean).join(', ');

        if (medStr) details.push(medStr);
      }

      // Familiares
      if (this.antecedente_usuario.familiares && this.antecedente_usuario.familiares.length) {
        const famStr = this.antecedente_usuario.familiares.map(f => {
          const par = f.parentesco ? f.parentesco.nombre : '';
          const diag = f.diagnostico ? (f.diagnostico.DESC_DIAG || f.diagnostico.DESCRIPCION || f.diagnostico.ID_DIAG) : '';
          return `${par} ${diag}`.trim();
        }).filter(Boolean).join(', ');

        if (famStr) details.push(famStr);
      }

      const newDetailsStr = details.join(' | ');

      if (newDetailsStr) {
        if (oldValor && oldValor.toUpperCase() !== 'SI' && oldValor.toUpperCase() !== 'NO' && !oldValor.includes(newDetailsStr)) {
          return `${oldValor} | ${newDetailsStr}`;
        } else {
          return newDetailsStr;
        }
      }

      return oldValor;
    }
  }
}
</script>
